const en = 'en';
const fr = 'fr';

const defaultLanguage = fr;

const defaultNamespace = 'common';

export { defaultLanguage, defaultNamespace, en, fr };
